import { render, staticRenderFns } from "./About.vue?vue&type=template&id=68d29a6c&scoped=true&"
var script = {}
import style0 from "./About.vue?vue&type=style&index=0&id=68d29a6c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68d29a6c",
  null
  
)

export default component.exports